import { render, staticRenderFns } from "./CustomerBillingAddress.vue?vue&type=template&id=2c9880ea"
import script from "./CustomerBillingAddress.vue?vue&type=script&lang=js"
export * from "./CustomerBillingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports